export enum EnvironmentalImpactEvents {
   
  CompletedGenerateEnvironmentalImpact = 'Arable_CompletedGenerateEnvironmentalImpact',
}

export interface CompletedGenerateEnvironmentalImpact {
  isSuccessful: boolean;
  year: number;
  cropFieldId: number;
  activeIngredientAmount: number;
}
